import React from 'react'
import { FormattedMessage as Lang } from 'react-intl'

import { Title, CheckBoxContainer, RadioButtonStyled } from './styles'
import { CONNECTED_LINES, MESH, OBJECTS } from '@/constants/instalationPassport/types'


const MapLayerMobile = ({
  mapLayer,
  setMapLayer
}) => {
  const handleSetCheckBox = (id) => {
    setMapLayer(id)
  }

  return (
    <>
   <Title main>Отображение слоев</Title>
   <CheckBoxContainer>
        <RadioButtonStyled
          active={mapLayer === OBJECTS}
          onChange={() => handleSetCheckBox(OBJECTS)}
          label={<Lang id="mapsPage.mapLayers.objects" />}
        />
      </CheckBoxContainer>
      <CheckBoxContainer >
        <RadioButtonStyled
          active={mapLayer === CONNECTED_LINES}
          onChange={() => handleSetCheckBox(CONNECTED_LINES)}
          label={<Lang id="mapsPage.mapLayers.lines" />}
        />
      </CheckBoxContainer>
      <CheckBoxContainer>
        <RadioButtonStyled
          active={mapLayer === MESH}
          onChange={() => handleSetCheckBox(MESH)}
          label={<Lang id="mapsPage.mapLayers.mesh" />}
        />
      </CheckBoxContainer>
   </>
  )
}



export default MapLayerMobile
